export default "__VITE_ASSET__SFuW07x$__"